import { MinutaToTasks } from '@/features/minuta/components/MinutaToTasks';
import { getProjectBySlugQuery } from '@/lib/supabase/queries/projects';
import { getWorkspaceBySlugQuery } from '@/lib/supabase/queries/workspaces';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/minuta')({
  component: MinutaPage,
});

function MinutaPage() {
  const { wsSlug, projectSlug } = useParams({
    from: '/_app/$wsSlug/projects/$projectSlug/minuta',
  });

  const wsQ = useQuery(getWorkspaceBySlugQuery(wsSlug));
  const projQ = useQuery({
    ...getProjectBySlugQuery(wsQ.data?.id ?? '', projectSlug),
    enabled: !!wsQ.data?.id,
  });

  if (wsQ.isPending || (wsQ.data && projQ.isPending)) {
    return <div className="p-6 text-sm text-quiet">Cargando proyecto...</div>;
  }
  if (!wsQ.data || !projQ.data) {
    return (
      <div className="p-6 text-sm text-quiet">
        Proyecto no encontrado o sin permisos para verlo.
      </div>
    );
  }

  const ws = wsQ.data;
  const project = projQ.data;

  return (
    <MinutaToTasks
      workspaceId={ws.id}
      projectId={project.id}
      wsSlug={wsSlug}
      projectSlug={projectSlug}
    />
  );
}
